<template lang="pug">
  hotsite(
    nome="Diretoria de Compras - DCOM"
    tema="theme-blue"
    capa="../../../static/banner_hotsite.jpg"
    :menu="aside_links",
    :links="footer_links",
    :breadcrumb="breadcrumb")
    template(slot="conteudo"): slot
</template>

<script>
  import Hotsite from 'MODULES/Hotsite'

  export default {

    components: {
      Hotsite
    },

    data () {
      return {
        breadcrumb: [
          { nome: 'DCOM', rota: 'DCOMIndex' }
        ],
        aside_links: [
          { id: 0, texto: 'Início', rota: 'DCOMIndex' },
          { id: 1, texto: 'Sobre a DCOM', rota: 'DCOMSobre' },
          { id: 2, texto: 'Orientações e Manuais', rota: 'DCOMOrientacoes' },
          // { id: 3, texto: 'Atas de Registro de Preço', rota: 'DCOMAtas' },
          { id: 3, texto: 'Editais de Licitações', rota: 'DCOMEditais' },
          { id: 4, texto: 'Legislação', rota: 'DCOMLegislacoes' },
          { id: 5, texto: 'Contatos', rota: 'DCOMContato' }
        ],
        footer_links: [
          { id: 0, texto: 'Portal de Compras - Governo Federal', url: 'https://www.comprasgovernamentais.gov.br/' },
          { id: 1, texto: 'SICAF', url: 'https://sicafdigital.com.br/' },
          { id: 2, texto: 'Diário Oficial da União', url: 'http://www.imprensanacional.gov.br/web/guest/inicio' },
          { id: 3, texto: 'Acesso à Informação - Governo Federal', url: 'http://www.acessoainformacao.gov.br/' },
          { id: 4, texto: 'Painel de Preços - Governo Federal', url: 'http://paineldeprecos.planejamento.gov.br/' }
        ]
      }
    },

    head: {
      title () {
        return {
          inner: `${this.$SITE_TITLE} - DCOM`
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// Base.vue?456cd408